module.exports = __webpack_public_path__ + "img/symbol_3.29465875.png";